import React, { useEffect, useCallback, useRef, useState } from "react";
import { Container, Paper } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import { API_KEY } from "../config";
import * as yup from "yup";
import { useFetch } from "../hooks";
import { Body1, H6 } from "../components/tipografia";
import { EntradaForm } from "../components";
import { ToastErro } from "../utils/utils";
import { toast } from "react-toastify";

// Schema de validacao dos daddos
const schemaValidator = yup.object().shape({
  senha: yup
    .string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!#%*?&])[A-Za-z\d@$!%#*?&]{8,}$/g
    )
    .required(),
  senha2: yup
    .string()
    .test("", "", function (value) {
      return value === this.parent.senha;
    })
    .required(),
  //   senha2: yup
  //     .string()
  //     .matches(
  //       /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!#%*?&])[A-Za-z\d@$!%#*?&]{8,}$/g
  //     )
  //     .required(),
});
const schemaMessageError = {
  senha: "* Não atende aos requisitos",
  senha2: " Não atende aos requisitos ou não são idênticas",
};
const schema = [
  {
    type: "password",
    icon: "VpnKey",
    name: "senha",
    placeholder: "Sua senha",
    label: "* Senha",
  },
  {
    type: "password",
    icon: "VpnKey",
    name: "senha2",
    placeholder: "Confirmar senha",
    label: "* Confirmar Senha",
  },
];

export default function RecuperarSenhaUsuario() {
  // Para referenciar o captcha invisivel
  const recaptchaRef = useRef();
  // Estado que controla a atividade do token
  const [token, setToken] = useState(null);
  return (
    <Container>
      <H6>Recuperação de senha</H6>
      <Body1 component="p" textAlign="center">
        Informe a nova senha e confirme. Lembre-se que a senha deve ter ao menos
        8 caracteres.
      </Body1>
      <Body1 comopnent="p" textAlign="center">
        Sendo que uma letra deve ser maiuscula, uma minuscula, um número e ao
        menos um dos caracteres especiais #!@$%
      </Body1>
      <br />
      <FormResetSenha
        token={token}
        setToken={setToken}
        recaptchaRef={recaptchaRef}
      />
      <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={API_KEY} />
    </Container>
  );
}

const FormResetSenha = ({ recaptchaRef, token, setToken }) => {
  const { wait, error, setFetch, data } = useFetch(
    "/recuperar_senha_usuario",
    "POST",
    "normal"
  );
  useEffect(() => {
    if (error) ToastErro(error);
  }, [error]);

  // Funcao para enviar os dados para autenticacao
  const onSubmit = useCallback(
    async (val) => {
      let TOKEN = recaptchaRef.current.getValue();
      if (!token) {
        TOKEN = await recaptchaRef.current.executeAsync();
        setToken(TOKEN);
      } else {
        await recaptchaRef.current.reset();
        TOKEN = await recaptchaRef.current.executeAsync();
      }

      // Valida se a senha e senha2 sao iguais
      if (val.senha !== val.senha2) {
        ToastErro("Erro, as senhas não são iguais");
        return false;
      }

      const TOKEN_RESET = new URLSearchParams(window.location.search).get(
        "token_id_reset"
      );

      const inDados = {
        token_id_reset: TOKEN_RESET,
        nova_senha: val.senha,
        captcha: TOKEN,
      };
      // Enviar para o backend
      setFetch(inDados);
    },
    [token, recaptchaRef, setFetch, setToken]
  );
  useEffect(() => {
    if (data) {
      toast.dark(data.sucesso, {
        type: "success",
      });
      setTimeout(() => {
        window.location.href = "/";
      }, 4000);
    }
  }, [data]);

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ my: 1, p: 1 }}>
        <EntradaForm
          schema={schema}
          onSubmit={onSubmit}
          schemaValidator={schemaValidator}
          schemaMessageError={schemaMessageError}
          wait={wait}
        />
      </Paper>
    </Container>
  );
};
